export class Utils {
  constructor() {}

  data(stringData) {
    var date = new Date(stringData)

    var year = date.getFullYear()
    var month = date.getMonth() + 1
    var day = date.getDate()

    var minutes = date.getMinutes()
    var hours = date.getHours()
    var seconds = date.getSeconds()

    if (hours < 10) hours = '0' + hours
    if (minutes < 10) minutes = '0' + minutes
    if (seconds < 10) seconds = '0' + seconds

    if (day < 10) {
      day = '0' + day
    }
    if (month < 10) {
      month = '0' + month
    }

    var formattedDate =
      day +
      '/' +
      month +
      '/' +
      year +
      '-' +
      hours +
      ':' +
      minutes +
      ':' +
      seconds
    return formattedDate
  }
  getStringFromObjectId(ObjectId) {
    return (
      ObjectId.timestamp.toString(16) +
      ObjectId.machineIdentifier.toString(16) +
      (65536 + ObjectId.processIdentifier).toString(16) +
      ObjectId.counter.toString(16)
    )
  }
  getEmailRules() {
    return [
      (v) =>
        /^$|^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
          v
        ) || 'E-mail invalid'
    ]
  }
  getBiggerRules(minLength) {
    return [
      (v) =>
        (v && v.length >= minLength) ||
        'Length must be bigger than ' + minLength.toString() + ' characters'
    ]
  }
  getLessRules(maxLength) {
    return [
      (v) =>
        (v && v.length <= maxLength) ||
        'Length must be less than ' + maxLength.toString() + ' characters'
    ]
  }
  getRequiredRules() {
    return [(v) => !!v || 'Item is required']
  }
  getPhoneRules() {
    return [(v) => /^$|^[0-9]{9,15}$/.test(v) || 'Phone number invalid']
  }
  getNumberRules() {
    return [(v) => /^[-+]?[0-9]*$/.test(v) || 'Number invalid']
  }
  getDecimalNumberRules() {
    return [
      (v) =>
        /^$|^[-+]?(?:0|0\.\d*|[1-9]\d*\.?\d*)$/.test(v) ||
        'Decimal number invalid'
    ]
  }
  getNameRules() {
    return [
      (v) =>
        /^([a-zA-Z]+(([',. -][a-zA-Z ])?[a-zA-Z]*)*)?$/.test(v) ||
        'Nume incorect'
    ]
  }
  getCnpRules() {
    return [
      (v) =>
        /^$|^[1-9]\d{2}(0[1-9]|1[0-2])(0[1-9]|[12]\d|3[01])(0[1-9]|[1-4]\d|5[0-2]|99)(00[1-9]|0[1-9]\d|[1-9]\d\d)\d$/.test(
          v
        ) || 'CNP Incorect'
    ]
  }
  getSerieRules() {
    return [(v) => /^$|^[A-Z]{2}$/.test(v) || 'Serie invalida']
  }
  getIdNumberRules() {
    return [(v) => /^$|^[0-9]{6}$/.test(v) || 'Numar act invalid']
  }
  getCardNumberRules() {
    return [
      (v) =>
        /^$|^(?:(?:IT|SM)\d{2}[A-Z]\d{22}|CY\d{2}[A-Z]\d{23}|NL\d{2}[A-Z]{4}\d{10}|LV\d{2}[A-Z]{4}\d{13}|(?:BG|BH|GB|IE)\d{2}[A-Z]{4}\d{14}|GI\d{2}[A-Z]{4}\d{15}|RO\d{2}[A-Z]{4}\d{16}|KW\d{2}[A-Z]{4}\d{22}|MT\d{2}[A-Z]{4}\d{23}|NO\d{13}|(?:DK|FI|GL|FO)\d{16}|MK\d{17}|(?:AT|EE|KZ|LU|XK)\d{18}|(?:BA|HR|LI|CH|CR)\d{19}|(?:GE|DE|LT|ME|RS)\d{20}|IL\d{21}|(?:AD|CZ|ES|MD|SA)\d{22}|PT\d{23}|(?:BE|IS)\d{24}|(?:FR|MR|MC)\d{25}|(?:AL|DO|LB|PL)\d{26}|(?:AZ|HU)\d{27}|(?:GR|MU)\d{28})$/.test(
          v
        ) || 'Card invalid'
    ]
  }
  getCuiRules() {
    return [(v) => /^$|^[0-9]{7}$/.test(v) || 'CUI Invalid']
  }
  getCaenRules() {
    return [(v) => /^$|^[0-9]{4}$/.test(v) || 'Cod caen invalid']
  }
  getProjectIdRules() {
    return [(v) => /^$|^[0-9]{5}$/.test(v) || 'Project ID Invalid']
  }
  getFaxRules() {
    return [
      (v) =>
        /^$|^(\+?\d{1,}(\s?|-?)\d*(\s?|-?)\(?\d{2,}\)?(\s?|-?)\d{3,}\s?\d{3,})$/.test(
          v
        ) || 'Fax invalid'
    ]
  }
}
